import React, { useContext, useState, useEffect } from "react";
import { Button, Input } from "antd";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";

const Trocar = (props) => {

  const styles = `
  .Trocar_header {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  }
  .Trocar_header_title {
  font-weight: 400;
  font-size: 24px;
  line-height: 27px;
  }
  .Trocar_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  padding: 30px;
  }
  .Trocar_itemField {
  padding: 10px 0px;
  width: 100%;
  }
  .Trocar_itemFieldLabel {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  }
  .Trocar_itemField input {
  border: 1px solid #55b962;
  border-radius: 4px;
  background-color: rgba(242, 242, 242, 0.4);
  }
  .ant-picker {
  width: 100%;
  }
  .Trocar_itemField input .Trocar_inputError {
  border: 1px solid #e46772;
  }
  .Trocar_saveBtn {
  margin-top: 20px;
  background-color: #0c8ce9;
  color: #fff;
  border-radius: 4px;
  height: 40px;
  }
  .Trocar_saveBtn:hover {
  background-color: #0c8ce9;
  color: #fff;
  }
  .Trocar_itemFieldError {
  color: #e46772;
  font-size: 14px;
  padding: 2px 0;
  }
    `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const { authInfo, setNotiMessage } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const token = authInfo?.dataUser?.token;

  const { id } = useParams();

  const [data, setData] = useState({
    novoId: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const onSave = () => {
    // check require
    let errorsTemp = {};
    if (data.novoId === "") {
      errorsTemp.novoId = "Este campo é obrigatório";
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);
    axios
      .put(
        `${process.env.REACT_APP_SERVIDOR}/recuperar-id-maquina/${id}`,
        { novoId: data.novoId },
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        setNotiMessage({
          type: "success",
          message: res?.data?.message,
        });
        navigate(
          `/cliente-maquinas/pagamentos/${data.novoId}`,
          {
            state: location.state,
          }
        );
      })
      .catch((err) => {
        setIsLoading(false);

        setNotiMessage({
          type: "error",
          message: err.response?.data?.error
            ? err.response?.data?.error :
            "Sua sessão expirou, faça login novamente. 08",
        });
      });
  };

  return (
    <>
      {isLoading && <LoadingAction />}
      <div>
        <div className="Trocar_header">
          <div className="Trocar_header_title">TROCAR O ID DESSA MAQUINA</div>
          <Button
            className="Botao-Voltar"
            onClick={() => {
              navigate(`/cliente-maquinas/pagamentos/${id}`, {
                state: location.state,
              });
            }}
          >
            <span>VOLTAR</span>
          </Button>
        </div>

        <div className="Trocar_content">
          <div className="Trocar_itemField">
            <label className="Trocar_itemFieldLabel" htmlFor="novoId">
              NOVO ID:
            </label>
            <Input
              placeholder={""}
              value={data.novoId}
              id="novoId"
              type="text"
              name="novoId"
              autoComplete="novoId"
              onChange={(event) => {
                handleChange("novoId", event.target.value);
              }}
              className={`${!!errors.novoId ? "Trocar_inputError" : ""}`}
            />
            {errors.novoId && (
              <div className="Trocar_itemFieldError">{errors.novoId}</div>
            )}
          </div>

          <Button
            className="Trocar_saveBtn"
            onClick={() => {
              if (!isLoading) onSave();
            }}
            disabled={isLoading}
          >
            ENVIAR
          </Button>
        </div>
      </div>
    </>
  );
};

export default Trocar;
